<template>
  <div>
      <v-toolbar card light flat dense >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <!-- <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title> -->
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="cxt.isFilterMode() && cxt.isSelectMode()" style="overflow:hidden" justify-end>
          </v-layout>
      </v-toolbar>
      <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="isSearching" :indeterminate="true"></v-progress-linear>
      <v-card-scroll :height="calcDialogScroll(48+48+52+102, 48+48+52+116)">
         <v-card-text>

          <v-layout row>
            <v-layout column>
              <v-textarea
                label="Введите список инн компаний"
                hint="Инн могут разделяться пробелами или запятыми, можно также вводить ОГРН (ogrn:1111111111111), НЗА (nza:11111111111), ОГРНИП (ogrnip:111111111111111)"
                :value="cxt.selectedIds"
                v-on:input="setSelectedIds"
                clearable
                persistent-hint
                rows="16"
                autofocus                
              ></v-textarea>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card-scroll>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import classes from '../../api/classes'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'list-selector-tab',
    components: {vCardScroll},
    data: () => ({
      cxt: null
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => item.ref.inn)
      })
      cxt.mode = classes.modes.SELECT
      cxt.filterMode = true
      this.cxt = cxt
    },
    mounted () {
      this.processMethodsQueue()
    },
    watch: {
      selected (newVal, oldVal) {
        let arr = newVal.map(r => r.replace('inn:', ''))
        this.cxt.setSelected(arr)
      },
      methodsQueue () {
        this.processMethodsQueue()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      partner: {
        type: Boolean,
        default: false
      },
      query: {
        type: String,
        default: null
      },
      selected: {
        type: Array,
        default: []
      },
      methodsQueue: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getItemSet: 'getSearchSet',
        getProfileHaveClient: 'getProfileHaveClient',
        renderReference: 'renderReference',
        calcDialogScroll: 'calcDialogScroll',
        getTags: 'getTags'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + '' : ''
        }
      },
      items () {
        return []
      },
      filteredItems () {
        return []
      },
      isSearching () {
        return false
      },
      getSearchTotal () {
        return this.cxt.selectedCount()
      }
    },
    methods: {
      processMethodsQueue () {
        if (!this.methodsQueue) return
        let len = this.methodsQueue.length
        for (let i = 0; i < len; i++) {
          let method = this.methodsQueue.shift()
          if (this[method.name]) {
            this[method.name](method.params)
          }
        }
      },
      setSelectedIds (value) {
        let codes = value ? value.match(/[0-9]{9,10}|nza:\d{11}|ogrn:\d{13}|ogrnip:\d{15}/g) : []
        let refCodes = codes.map(code => code.includes(':') ? code : 'inn:' + code)
        this.$emit('input', refCodes)
      }
    }

  }

</script>



// WEBPACK FOOTER //
// ListSelectorTab.vue?3d43f80c